import Reac, { useCallback, useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AgentPayNowForm from "./AgentPayNowForm";
import { agentPaymentHistoryColumns } from "../../tables/agentPaymentHistoryColumns";
import AdminDataTable from "../../components/common/AdminDataTable";
import AgentPaymentFiltter from "./AgentPaymentFiltter";


export default function AgentPayNow() {

  const PAGE_SIZE = 10;
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);
  const token = localStorage.getItem("adminToken");
  const [history, setHistory] = useState([]);
  const [agentDetails, setAgentDetails] = useState(null);
  
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  const baseName = window.location.pathname.split("/").pop();
 const fetchHistory = useCallback(async (pageNumber = 1, filterParams = {}) => {

    setListLoading(true);
    try {
       const params = {
              page: pageNumber,
              limit: pageSize,
              sortBy,
              sortOrder,
              ...filterParams,
            };
             const queryString = new URLSearchParams(params).toString();
     const url = `${API_URL}/api/admin/agents/payment-history/${baseName}?${queryString}`;


      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) throw new Error("Failed to fetch history");

      const data = await response.json();

      setHistory(data.data || []);
      setTotalPages(Math.ceil((data.totalCount || 0) / pageSize));
    } catch (error) {
      console.error("Error fetching history:", error);
    } finally {
      setListLoading(false);
    }
  }, [API_URL, baseName, pageSize, sortBy, sortOrder, token]);

  const fetchAgentDetails = useCallback(async () => {
    try {
      const url = `${API_URL}/api/admin/agents/${baseName}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) throw new Error("Failed to fetch agent details");

      const data = await response.json();

      if (data.status) {
        setAgentDetails(data.data);
      } else {
        alert("Agent not found");
      }
    } catch (error) {
      console.error("Error fetching agent details:", error);
    }
  }, [API_URL, baseName, token]);

  const columns = agentPaymentHistoryColumns();
   const handleSort = (column) => {
      if (!column) return;

      if (sortBy === column) {
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
      } else {
        setSortBy(column);
        setSortOrder("asc");
      }
    };

      const handleFilter = ({ fromDate, toDate }) => {
          const filterParams = {};
          if (fromDate) filterParams.fromDate = fromDate;
          if (toDate) filterParams.toDate = toDate;

          fetchHistory(page ,filterParams);
        };

  useEffect(() => {
    fetchAgentDetails();
    fetchHistory(page);
  }, [page, fetchAgentDetails, fetchHistory]);

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="Agent Pay Now" />

        <>
          {/* page content */}
          <div className="right_col" role="main">
          
            {/* /top tiles */}
            <AgentPayNowForm agentDetails={agentDetails} baseName={baseName} fetchHistory={fetchHistory} fetchAgentDetails={fetchAgentDetails} token={token} />

            <div className="x_panel">
              <div className="x_title">
                <h2>Agent Payment History</h2>
                <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                  <li>
                    <a className="collapse-link">
                      <i className="fa fa-chevron-up" />
                    </a>
                  </li>

                </ul>
                <div className="clearfix" />
              </div>
              <div className="x_content">
                <div className="row">
                  <div className="col-sm-12">
                    <AgentPaymentFiltter onFilter={handleFilter} />
                    {/* filter end */}

                    <AdminDataTable
                      columns={columns}
                      data={history}
                      loading={listLoading}
                      page={page}
                      pageSize={pageSize}
                      totalPages={totalPages}
                      onPageSizeChange={(size) => {
                          setPageSize(size);  
                          setPage(1);         
                          fetchHistory(1, size); 
                        }}
                      sortBy={sortBy}
                      sortOrder={sortOrder}
                      onSort={handleSort}
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
          {/* /page content */}
        </>

        <Footer />
      </div>
    </div>
  );
}